var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconShapes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 17.95C8.16667 17.9667 8.32917 17.9792 8.4875 17.9875C8.64583 17.9958 8.81667 18 9 18C9.18333 18 9.35417 17.9958 9.5125 17.9875C9.67083 17.9792 9.83333 17.9667 10 17.95V20H20V10H17.95C17.9667 9.83333 17.9792 9.67083 17.9875 9.5125C17.9958 9.35417 18 9.18333 18 9C18 8.81667 17.9958 8.64583 17.9875 8.4875C17.9792 8.32917 17.9667 8.16667 17.95 8H20C20.55 8 21.0208 8.19583 21.4125 8.5875C21.8042 8.97917 22 9.45 22 10V20C22 20.55 21.8042 21.0208 21.4125 21.4125C21.0208 21.8042 20.55 22 20 22H10C9.45 22 8.97917 21.8042 8.5875 21.4125C8.19583 21.0208 8 20.55 8 20V17.95ZM9 16C7.05 16 5.39583 15.3208 4.0375 13.9625C2.67917 12.6042 2 10.95 2 9C2 7.05 2.67917 5.39583 4.0375 4.0375C5.39583 2.67917 7.05 2 9 2C10.95 2 12.6042 2.67917 13.9625 4.0375C15.3208 5.39583 16 7.05 16 9C16 10.95 15.3208 12.6042 13.9625 13.9625C12.6042 15.3208 10.95 16 9 16ZM9 14C10.3833 14 11.5625 13.5125 12.5375 12.5375C13.5125 11.5625 14 10.3833 14 9C14 7.61667 13.5125 6.4375 12.5375 5.4625C11.5625 4.4875 10.3833 4 9 4C7.61667 4 6.4375 4.4875 5.4625 5.4625C4.4875 6.4375 4 7.61667 4 9C4 10.3833 4.4875 11.5625 5.4625 12.5375C6.4375 13.5125 7.61667 14 9 14Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShapes);
export default __webpack_public_path__ + "static/media/icon-shapes.fc554d778f0298ed7c4d335cd063b5bf.svg";
export { ForwardRef as ReactComponent };